import gql from 'graphql-tag'

const languages = JSON.parse(process.env.VUE_APP_I18N_LANGUAGES || ["DE","EN"]).map(lang => lang.toUpperCase());
const titleFields = languages.map(lang => `title${lang.charAt(0)}${lang.slice(1).toLowerCase()}`).join('\n');
const textFields = languages.map(lang => `text${lang.charAt(0)}${lang.slice(1).toLowerCase()}`).join('\n');

export const NEWS_QUERY = gql`
query GenericNews($limit: Int){
  news(limit: $limit) {
    results {
      id
      text
      title
      ${titleFields}
      ${textFields}
      importantUntil
      newsType
      tags {
        name
        order
      }
      countries {
        id
        nameShort
        iso2
      }
      image
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
      modifiedAt
      modifiedBy {
        id
        firstName
        lastName
      }
      significantUpdateAt
    }
  }
}
`

export const NEWS_CREATE_MUTATION = gql`
mutation CreateNews($input: NewsCreateGenericType!) {
  createNews(input: $input) {
    news {
      id
    }
    ok
    errors {
      field
      messages
    }
  }
}
`

export const NEWS_UPDATE_MUTATION = gql`
mutation UpdateNews($input: NewsUpdateGenericType!) {
  updateNews(input: $input) {
    news {
      id
    }
    ok
    errors {
      field
      messages
    }
  }
}
`


export const NEWS_DELETE_MUTATION = gql`
mutation DeleteNews($id: ID!) {
  deleteNews(id: $id) {
    news {
      id
    }
    ok
    errors {
      field
      messages
    }
  }
}
`
